/**
 * @generated SignedSource<<c86286c7a1acd3a95b8012765a30c305>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "widgetsIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "widgetsIds",
        "variableName": "widgetsIds"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "deleteWidgets",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteWidgetsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteWidgetsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "83711717a84822cef7f98240a9a0491d",
    "id": null,
    "metadata": {},
    "name": "DeleteWidgetsMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteWidgetsMutation(\n  $widgetsIds: [ID]!\n) {\n  deleteWidgets(widgetsIds: $widgetsIds) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "a35a4925f9e267a96d0b5420813ab89c";

export default node;
